module.exports = __webpack_public_path__ + "static/img/cont606.50c3318.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont606.jpg
// module id = rTJh
// module chunks = 0